// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldset-style{
  margin-top: 30px;
}
.flx-end{
  display: flex;
  justify-content: flex-end;
}

.surveyDb{
  margin-bottom: 12px;
}
.d-flexend{
  display: flex;
  justify-content: flex-end;
  gap:12px;
}
.mssg-green{
  color:green
}
.mssg-red{
  color:red
}`, "",{"version":3,"sources":["webpack://./src/views/find/Find.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE;AACF;AACA;EACE;AACF","sourcesContent":[".fieldset-style{\n  margin-top: 30px;\n}\n.flx-end{\n  display: flex;\n  justify-content: flex-end;\n}\n\n.surveyDb{\n  margin-bottom: 12px;\n}\n.d-flexend{\n  display: flex;\n  justify-content: flex-end;\n  gap:12px;\n}\n.mssg-green{\n  color:green\n}\n.mssg-red{\n  color:red\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
